import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { scrollToSection } from '../../utils/scrollToSection';
import { t } from '../../utils/translations';
import logo from '../../assets/images/logo-white.png';
import whatsapp from '../../assets/images/whatsapp.png';
import facebook from '../../assets/images/facebook.png';
import instagram from '../../assets/images/instagram.png';
import twitter from '../../assets/images/twitter.png';
import snapchat from '../../assets/images/snapchat.png';
import linkedin from '../../assets/images/linkedin-white.png';

const LandingFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const lang = localStorage.getItem('locale') || 'en';
  const appName = process.env.REACT_APP_NAME || 'Fesilah';
  const adminEmail = process.env.REACT_APP_ADMIN_EMAIL || 'contact@fesilah.ae';
  const navigate = useNavigate();
  const location = useLocation();

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      if (path === '/home' || path === location.pathname) {
        // Same page, scroll to section
        scrollToSection(hash, 100);
      } else {
        // Different page, navigate then scroll
        navigate(path);
        setTimeout(() => {
          scrollToSection(hash, 100);
        }, 100);
      }
    } else {
      navigate(href);
    }
  };

  return (
    <footer className="p-15 mb-n20 bg-base">
      <div className="container">
        <div className="row mt-10 fs-lg-5">
          <div className="col-md-4 text-center">
            <p>
              <Link to="/home">
                <img src={logo} width="150px" className="mb-10" alt="logo" />
              </Link>
            </p>
            <p className="text-center p-3 text-white mt-3 fs-lg-5">ⓒ {currentYear} {appName} | {t('All rights reserved', lang)}</p>
            <div>
              <a href="https://wa.me/+971561560136" target="_blank" rel="noopener noreferrer">
                <img src={whatsapp} width="35px" className="mx-3" alt="whatsapp" />
              </a>
              <a href="https://www.linkedin.com/company/fesilah/" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} width="35px" className="mx-3" alt="linkedin" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100093702834699&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                <img src={facebook} width="35px" className="mx-3" alt="facebook" />
              </a>
              <a href="https://instagram.com/fesilah" target="_blank" rel="noopener noreferrer">
                <img src={instagram} width="35px" className="mx-3" alt="instagram" />
              </a>
              <a href="https://twitter.com/fesilah" target="_blank" rel="noopener noreferrer">
                <img src={twitter} width="30px" className="mx-3" alt="spacex" />
              </a>
              <a href="https://t.snapchat.com/SjEcCxsb" target="_blank" rel="noopener noreferrer">
                <img src={snapchat} width="45px" className="mx-3" alt="snapchat" />
              </a>
            </div>
          </div>
          <div className="col-md-2 col-6 mt-lg-0 mt-10">
            <ul className="menu menu-column">
              <li className="nav-item py-3 text-white">
                <Link to="/home" className="nav-link">{t('Home', lang)}</Link>
              </li>
              <li className="nav-item py-3 text-white">
                <a href="/home#about" className="nav-link" onClick={(e) => handleAnchorClick(e, '/home#about')}>{t('About Fesilah', lang)}</a>
              </li>
              <li className="nav-item py-3 text-white">
                <a href="/home#features" className="nav-link" onClick={(e) => handleAnchorClick(e, '/home#features')}>{t('Features', lang)}</a>
              </li>
              <li className="nav-item py-3 text-white">
                <a href="/home#faqs" className="nav-link" onClick={(e) => handleAnchorClick(e, '/home#faqs')}>{t('FAQS', lang)}</a>
              </li>
              <li className="nav-item py-3 text-white">
                <a href="/home#download" className="nav-link" onClick={(e) => handleAnchorClick(e, '/home#download')}>{t('Download App', lang)}</a>
              </li>
            </ul>
          </div>
          <div className="col-md-2 col-6 mt-lg-0 mt-10">
            <ul className="menu menu-column">
              <li className="nav-item py-3 text-white">
                <Link to="/privacy-policy" className="nav-link">{t('Privacy Policy', lang)}</Link>
              </li>
              <li className="nav-item py-3 text-white">
                <Link to="/terms-conditions" className="nav-link">{t('Terms & Conditions', lang)}</Link>
              </li>
              <li className="nav-item py-3 text-white">
                <Link to="/return-refund" className="nav-link">{t('Return & Refund', lang)}</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-4 col-12 mt-lg-0 mt-10">
            <h4 className="text-white fs-1 mb-10">{t('Contact Us', lang)}</h4>
            <p className="text-white fs-4" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
              <a href={`mailto:${adminEmail}`} className="text-white">
                <i className="fas fa-envelope fs-4 text-white me-5"></i> {t('Contact Email', lang)}: {adminEmail}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;


